import React from "react";

export const Deals = () => {
    return (
        <React.Fragment>
            <h1>Aanbiedingen</h1>
            <p>Er zijn op dit moment geen aanbiedingen.</p>
        </React.Fragment>
    );
}